import config from './aws-exports';

/**
 * SSO-specific Amplify configuration.
 * Reuses the existing app client from aws-exports and adds OAuth settings
 * needed for the SAML redirect flow.
 *
 * The Cognito domain must be created manually (or via CLI) per environment:
 *   aws cognito-idp create-user-pool-domain --user-pool-id <pool-id> --domain <prefix>
 *
 * Then set the REACT_APP_SSO_COGNITO_DOMAIN env var for each environment.
 * For local dev, set it in .env.development.
 */

const cognitoDomain = process.env.REACT_APP_SSO_COGNITO_DOMAIN || 'velocity.auth.af-south-1.amazoncognito.com';

// Remove the empty oauth object from aws-exports so Amplify v6 doesn't treat it as "configured but empty"
const { oauth: _discardEmpty, ...baseConfig } = config;

const ssoConfig = {
	...baseConfig,
	oauth: {
		domain: cognitoDomain,
		scope: ['openid', 'email'],
		redirectSignIn: `${window.location.origin}/sso/callback`,
		redirectSignOut: `${window.location.origin}/sso`,
		responseType: 'code',
	},
};

export default ssoConfig;
